import { render, staticRenderFns } from "./Auxiliary.vue?vue&type=template&id=620c437c&scoped=true&"
import script from "./Auxiliary.vue?vue&type=script&lang=javascript&"
export * from "./Auxiliary.vue?vue&type=script&lang=javascript&"
import style0 from "./Auxiliary.vue?vue&type=style&index=0&id=620c437c&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "620c437c",
  null
  
)

export default component.exports